<template>
    <div v-if="!state.loading">
        <div class="pgehd">
            <h2>{{ state.title }}</h2>
            <div class="pgectr">
                <span class="pgebtn" @click="createnew">
                    Add Questions
                </span>
            </div>
        </div>
        
        <PrimeDataTable
            :value="list"
            :rows="10"
            responsiveLayout="scroll"
            stripedRows>
            
            <PrimeColumn field="num" header="Num" />
            <PrimeColumn field="question" header="Question">
                <template #body="slotProps">
                    <div v-html="slotProps.data.question"></div>
                </template>
            </PrimeColumn>
            <PrimeColumn field="type" header="Type" />
            <PrimeColumn field="objective" header="Objectives">
                <template #body="slotProps">
                    <div v-html="slotProps.data.objective"></div>
                </template>
            </PrimeColumn>
        </PrimeDataTable>
    </div>
    <div v-else class="loader">
        <img src="@/assets/img/ajldr.gif" />
    </div>

    <ModalView
        :isVisible="state.createModal"
        :fixclose="true"
        @close="state.createModal = false">
        <div class="qwrap" v-for="(row, rowIndex) in formField" :key="rowIndex">
            <span style="margin:15px 0px 5px; display:block">Question {{ row.label }}</span>
            <EditorView v-model="qcontent[row.name]" />
            <div class="canswrap">
                <div>
                    <span style="margin:15px 0px 5px; display:block">Option A</span>
                    <input type='text' v-model="qcontent[row.name+'_a']" />
                </div>
                <div>
                    <span style="margin:15px 0px 5px; display:block">Option B</span>
                    <input type='text' v-model="qcontent[row.name+'_b']" />
                </div>
                <div>
                    <span style="margin:15px 0px 5px; display:block">Option C</span>
                    <input type='text' v-model="qcontent[row.name+'_c']" />
                </div>
                <div>
                    <span style="margin:15px 0px 5px; display:block">Option D</span>
                    <input type='text' v-model="qcontent[row.name+'_d']" />
                </div>
                <div>
                    <span style="margin:15px 0px 5px; display:block">Answer</span>
                    <select v-model="qcontent[row.name+'_ans']">
                        <option value="">Choose Answer</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                    </select>
                </div>
            </div>
        </div>

        <div v-if="!state.success">
            <div v-if="!state.submitting" class="btnwrap">
                <button @click="addMore" class="btn-secondary">Add Question</button>
                <button class="btn-primary" @click="addQuestion">Submit</button>
            </div>
            <div style="text-align:center" v-else>
                <img src="@/assets/img/ajldr.gif" width="90px"/>
            </div>
        </div>
        <div v-else>
            <p style="background:green; color:white; margin:10px auto; width:80%">Questions Successfully Added</p>
        </div>

    </ModalView>

</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import { useRoute } from "vue-router";
import ModalView from "@/components/ModalView.vue";
import EditorView from '@/components/EditorView.vue'

export default {
    name:"TestQuestions",
    components:{ModalView,EditorView},
    setup(){
        const qcontent=ref({})
        const state=reactive({loading:true, title:"Test Questions"})
        const list = ref([])
        const formField=ref([
        {label:"1", name: "Q1"}
        ])
        const globalFilter=ref("")
        const route = useRoute();
        const subject = computed(() => route.params.sub);
        const id = computed(() => route.params.id);
        const group = computed(() => route.params.group);

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        onMounted(() => {
            call({
                url:urls.test,
                data:{getQuestions:id.value, grade:group.value, sub:subject.value},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        setTable(res.msg.list)
                        state.title=res.msg.title;
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function createnew(){
            if(!state.success && !state.submitting){
                formField.value=[
                    {label:"1", name: "Q1"}
                ]
                qcontent.value["Q1"]="";
                qcontent.value["Q1_a"]="";
                qcontent.value["Q1_b"]="";
                qcontent.value["Q1_c"]="";
                qcontent.value["Q1_d"]="";
                qcontent.value["Q1_ans"]="";
            }
            state.createModal=true;
            state.submitting=false;
            state.errors=[];
            state.success=false;
        }

        function addQuestion(){
            var data={
                question:{ ...qcontent.value},
                addTestQuestion:id.value,
                length:formField.value.length,
                group:group.value, 
                sub:subject.value
            }
            state.submitting=true;
            state.errors=[];
            state.success=false;
            call({
                url:urls.test,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg)
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function addMore(){
            var num=formField.value.length+1;
            formField.value.push({
                label:num, name:"Q"+num
            })
        }
        
        return {list,globalFilter, state, createnew,addMore, addQuestion,formField,qcontent}
    }
}
</script>
<style scoped>
.qwrap:nth-child(even){background:#fafafa}
.canswrap{display: flex; flex-wrap: wrap; gap: 10px;}
:deep(.p-datatable-table img){max-width:200px !important}
</style>